import React from 'react';
import Proptypes from 'prop-types';
import backIcon from '../images/chevron-left.svg';
import '../styles/hcHomepageStyles.css';

export const NavBar = (props) => {
    return (
        <div className="navBar">
            <button
                className="navBar"
                onClick={() => props.handleHomeClick()}
            >
                <img
                    src={backIcon}
                    alt="Back Icon"
                />
                &nbsp;HOME
            </button>
        </div>
    );
};

NavBar.propTypes = {
    handleHomeClick: Proptypes.func.isRequired,
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar.jsx